export const FETCH_SHIPPING_USER_SUGGEST = {
    REQUEST: 'FETCH_SHIPPING_USER_SUGGEST.REQUEST',
    SUCCESS: 'FETCH_SHIPPING_USER_SUGGEST.SUCCESS',
    FAILED: 'FETCH_SHIPPING_USER_SUGGEST.FAILED',
};